import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { PlayerKey } from "../assets/script/constants";

/**
 * @name BaseArea
 * @class BaseArea
 * @extends {ConnectedHTMLElement}
 * @description
 *
 */
export class BaseArea extends ConnectedHTMLElement {
  static observedAttributes = ["player"];

  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    const player = this.getAttribute("player");
    if (
      newState[player].base !== oldState[player].base &&
      newState[player].base !== undefined
    ) {
      const img = this.querySelector("div");
      if (img) {
        img.style.backgroundImage = `url(/assets/img/${newState[player].base.img.hs})`;
      }
    }
    if (newState[player].base === undefined) {
      const img = this.querySelector("div");
      if (img) {
        img.style.backgroundImage = `url(/assets/img/han-solo.png)`;
      }
    }
  }

  render() {
    const player = this.getAttribute("player");
    const wHeight = window.innerHeight / 2;
    const aspectRatio = 418 / 300;
    const wWidth = window.innerWidth > 500 ? 500 : window.innerWidth; // width of the screen
    const imgHeight = wWidth / aspectRatio; // height of the image based on the width
    const availableHeight = wHeight - 114;
    let marginToAdd = 0;
    if (imgHeight > availableHeight) {
      marginToAdd = imgHeight - availableHeight;
    }

    this.innerHTML = `
      <div
        class="bg-base-300 max-h-[50vh] min-h-[50vh] bg-no-repeat bg-bottom absolute left-0 z-0 bg-contain w-full 
${player === PlayerKey.top ? "" : ""}"
        style="background-image: url(/assets/img/han-solo.png); bottom: ${marginToAdd !== 0 ? `-${marginToAdd}px` : "0"};"
      >
        <select-base player="${player}"></select-base>
        <counter-value player="${player}">
      </div>
    `;
  }

  connectedCallback() {
    this.render();
  }

  dispatchEvent(event) {
    return false;
  }
}
